import { useSelector } from 'react-redux'
import { ABOUT_US_VARIANT } from '../../constants/uiConfig'
import AboutUsV1 from './AboutUsV1'
import AboutUsV2 from './AboutUsV2'

const AboutUs = () => {
  const variant = useSelector(state => state?.uiConfig?.general?.aboutUsVariant)
  const showMoreBreakpoint = useSelector(state => state?.uiConfig?.general?.showMoreBreakpoint)

  if (variant === ABOUT_US_VARIANT.V1) {
    return (
      <AboutUsV1 showMoreBreakpoint={showMoreBreakpoint} />
    )
  } else if (variant === ABOUT_US_VARIANT.V2) {
    return (
      <AboutUsV2 />
    )
  }

  return null
}

export default AboutUs
